<template>
  <LazyHomeCommonLayout :scroll-class="scrollClassText" :is-main="true">
    <template #content>
      <section v-if="isOnLoad" class="settingWrap">
        <div class="containerDash">
          <div class="settingArea flex">
            <LazyUserSettingsCommonMenu :tab="tab"/>
            <div class="right">
              <keep-alive>
                <component :is="currentTabComponent" />
              </keep-alive>
            </div>
          </div>
        </div>
      </section>
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {LazyHomeCommonLayout} from '#components';
import UserSettingsAccount from '~/components/User/Settings/Account/UserSettingsAccount.vue';
import UserSettingsNotifications from '~/components/User/Settings/Notifications/UserSettingsNotifications.vue';
import {useLoadingStore} from '~/store/loading/loadingStore';
import {UserSettingsMenuType} from '~/components/User/Settings/Common/model/UserSettingsMenuType';
import {ref} from '#imports';
import {useUserStore} from '~/store/user/userStore';
import {computed} from 'vue';

const route = useRoute();
const router = useRouter();
const tab = ref<UserSettingsMenuType>(route.query.tab as UserSettingsMenuType);

const userStore = useUserStore();
const loadingStore = useLoadingStore();

const isOnLoad = ref(false);

const lastScrollY = ref(0);
const scrollClass = ref({hidden: false, on: false});

const currentTabComponent = computed(() => {
  if (tab.value === UserSettingsMenuType.Notifications) {
    return UserSettingsNotifications;
  } else return UserSettingsAccount;
});

const setScrollEvent = () => {
  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;
    scrollClass.value.hidden = currentScrollY > lastScrollY.value && currentScrollY > 100;
    scrollClass.value.on = currentScrollY > 0;
    lastScrollY.value = currentScrollY;
  });
}
const handleRegisterInfo = () => {
  if (userStore.isLogin()) {
    if (!userStore.userV2.location) router.replace({path: "/register/info"});
    else {
      loadingStore.closeLoading();
      isOnLoad.value = !loadingStore.show;
    }
  } else {
    router.replace({path: "/"});
  }
}

const scrollClassText = computed(() => {
  let text = "";
  if (scrollClass.value.hidden) text += "hidden ";
  if (scrollClass.value.on) text += "on ";
  return text;
});

onMounted(() => {
  lastScrollY.value = window.scrollY;
  setScrollEvent();
  handleRegisterInfo();
});

watch(() => route.query.tab, () => {
  if (route.query.tab) tab.value = route.query.tab as UserSettingsMenuType;
  else tab.value = UserSettingsMenuType.Account;
}, { immediate: true });
</script>

<style>
@import "assets/scss/setting_style.scss";
</style>